import SpreadsheetBoxItem from "./SpreadsheetBoxItem/SpreadsheetBoxItem";

export default {
  components: {
    SpreadsheetBoxItem,
  },
  props: {
    currentSpreadsheetTab: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
    },
    isLoadingMore: {
      type: Boolean,
    }
  },

  data() {
    return {
    };
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/Orders/SpreadsheetsList/spreadsheetsList.js